import { render, staticRenderFns } from "./DetailPageLeft.vue?vue&type=template&id=9b550d2a"
import script from "./DetailPageLeft.vue?vue&type=script&lang=js"
export * from "./DetailPageLeft.vue?vue&type=script&lang=js"
import style0 from "./DetailPageLeft.vue?vue&type=style&index=0&id=9b550d2a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports